import React from "react";
import {useCurrentUser} from "../../../../../../../contexts/UserContext";
import {Flex} from "antd";
import PackingSlipButton from "./PackingSlipButton";
import {FilePdf} from "@phosphor-icons/react";

const PackingSlipSection: React.FC = () => {

    const {hasCapability} = useCurrentUser();

    return (
        <>
            {
                hasCapability('Packing_Slip') &&

                <>
                    <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}>
                        <FilePdf size={32}/>Packing Slip
                    </Flex>

                    <PackingSlipButton shortened={false}/>

                    <PackingSlipButton shortened={true}/>
                </>
            }
        </>
    )
}

export default PackingSlipSection;